/** @format */

import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { RiHomeLine } from 'react-icons/ri';
import { LuUserRound } from 'react-icons/lu';
import { FiBook, FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import myLogo from '../../assets/llb360.png';
import { ROUTES } from '../../constant/routes';

interface NavItem {
	id: string;
	icon: React.ReactElement;
	title: string;
}

interface SidebarProps {
	onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onLogout }) => {
	const location = useLocation();
	const [isOpen, setIsOpen] = useState(false);

	const navItems: NavItem[] = [
		{
			id: ROUTES.DASHBOARD,
			icon: <RiHomeLine size={24} />,
			title: 'Dashboard',
		},
		{ id: ROUTES.SUBJECT, icon: <FiBook size={24} />, title: 'Subject' },
		{ id: ROUTES.PROFILE, icon: <LuUserRound size={24} />, title: 'Profile' },
	];

	const toggleSidebar = () => {
		setIsOpen(!isOpen);
	};

	return (
		<>
			<div className='flex justify-between items-center md:hidden'>
				<Link to={ROUTES.DASHBOARD}>
					<img
						src={myLogo}
						alt='llb360 logo'
						className='sideBarLogo'
					/>
				</Link>
				<button
					className='md:hidden sideBarNavItem active'
					onClick={toggleSidebar}>
					{isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
				</button>
			</div>

			<nav className='dashboardNav'>
				<ul className='sideBarContainer'>
					<li>
						<Link to={ROUTES.DASHBOARD}>
							<img
								src={myLogo}
								alt='llb360 logo'
								className='sideBarLogo'
							/>
						</Link>
					</li>
					{navItems.map((item) => (
						<li key={item.id}>
							<Link
								to={item.id}
								className={`sideBarNavItem
                  ${location.pathname === item.id ? 'active' : ''}`}
								title={item.title}
								aria-label={item.title}>
								{item.icon}{' '}
								<span className='md:block hidden text-xs'>{item.title}</span>
							</Link>
						</li>
					))}
				</ul>

				<button
					onClick={onLogout}
					className='logOutBtn md:block hidden'>
					<FiLogOut size={24} />
				</button>
			</nav>

			<nav
				className={`md:hidden fixed top-24 left-0 right-0 z-40 bg-myDark text-white transition-all transform duration-300 ease-in-out overflow-y-auto shadow-xl rounded-b-xl max-h-[80vh]
          ${
						isOpen
							? 'opacity-100 pointer-events-auto translate-y-0'
							: 'opacity-0 pointer-events-none -translate-y-2'
					}
        `}>
				<ul className='sideBarMobileContainer px-4 py-2'>
					{navItems.map((item) => (
						<li key={item.id}>
							<Link
								to={item.id}
								className={`sideBarNavItem
                  ${location.pathname === item.id ? 'active' : ''}`}
								onClick={() => setIsOpen(false)}
								title={item.title}
								aria-label={item.title}>
								{item.icon}{' '}
								<span className='block md:hidden text-xs'>{item.title}</span>
							</Link>
						</li>
					))}
					<li>
						<button
							onClick={onLogout}
							className='sideBarNavItem md:hidden text-xs'>
							<FiLogOut size={24} /> Logout
						</button>
					</li>
				</ul>
			</nav>
		</>
	);
};

export default Sidebar;
